
export const SellerSizeGuideQuery = new TypedDocumentString(`
    query SellerSizeGuideQuery($guideId: ObjectId!) {
  publicSizeGuide(guideId: $guideId) {
    ...SellerSizeGuide
    __typename
  }
}
    fragment SellerSizeGuide on SellerSizeGuide {
  _id
  title {
    value
    __typename
  }
  image {
    ...Image
    __typename
  }
  sizes {
    key
    title {
      value
      __typename
    }
    __typename
  }
  areas {
    key
    name
    title {
      value
      __typename
    }
    description {
      value
      __typename
    }
    __typename
  }
  units {
    key
    unit
    __typename
  }
  values {
    sizeKey
    areaKey
    unitKey
    value
    __typename
  }
  instructionsNote {
    value
    __typename
  }
  measurmentsNote {
    value
    __typename
  }
  __typename
}
fragment DocumentColorHsla on DocumentColorHsla {
  h
  s
  l
  a
  __typename
}
fragment ImageNodeItem on ImageNodeItem {
  _id
  alt
  uploadDate
  type
  url
  fallbackUrl
  img
  height
  width
  noProxy
  hsla {
    ...DocumentColorHsla
    __typename
  }
  aspect {
    x
    y
    __typename
  }
  audio
  videoHls
  video
  isVideo
  __typename
}
fragment Image on Image {
  alt {
    value
    __typename
  }
  isVideo
  image2 {
    ...ImageNodeItem
    __typename
  }
  __typename
}`, {"hash":"abaee9fe87ee47d803819c949279f3ced5375459f88074d9add5935214545ddb"});